import React from 'react'
import styled from '@emotion/styled'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint } from 'src/components/shared/CssValues'

/**
 * 複数行のテキストを任意の行で省略し、末尾に3点リーダを付与する
 */
const OmittedText = ({ value, ...props }) => <Text {...props}>{value}</Text>

const Text = styled(Typography)`
  overflow: hidden;
  position: relative;
  height: ${props =>
    `${(props.fontSize ?? 16) *
      (props.lineHeight ?? 1) *
      (props.lines ?? 2)}px`};
  font-size: ${props => `${props.fontSize}px`};
  line-height: ${props => props.lineHeight};
  background-color: ${props => props.bgColor || '#fff'};
  text-align: justify;
  word-break: break-all;

  &:before,
  &:after {
    position: absolute;
  }

  &:before {
    top: ${props =>
      `${(props.fontSize ?? 16) *
        (props.lineHeight ?? 1) *
        ((props.lines ?? 2) - 1)}px`};
    right: 0;
    width: 1em !important;
    background-color: ${props => props.bgColor || '#fff'};
    content: '...';
    text-align: center;
  }

  &:after {
    z-index: 2;
    width: 100%;
    height: 100%;
    background-color: ${props => props.bgColor || '#fff'};
    content: '';
  }

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    height: ${props =>
      `${(props.spFontSize ?? props.fontSize ?? 16) *
        (props.spLineHeight ?? props.lineHeight ?? 1) *
        (props.spLines ?? props.lines ?? 2)}px`};
    font-size: ${props => `${props.spFontSize ?? props.fontSize}px`};
    line-height: ${props => props.spLineHeight ?? props.lineHeight};

    &:before {
      top: ${props =>
        `${(props.spFontSize ?? props.fontSize ?? 16) *
          (props.spLineHeight ?? props.lineHeight ?? 1) *
          ((props.spLines ?? props.lines ?? 2) - 1)}px`};
      right: 0;
    }
  }
`

export default OmittedText
